/**
 * IMPORTANT: Fictiv Engineers, when changing `keyFields` it is critical to update ALL queries that use that object type
 * so that they include ALL the key fields.  If a key field is missing an INVARIANT ERROR will be logged to the console
 * and the app will break.
 */
export const introspectionQueryResultData = {
    addTypename: true,
    possibleTypes: {
        name: [
            'Annotation',
            'Revision',
            'Attachment',
            'QuoteModelRevision',
            'QuoteAttachmentRevision',
        ],
        Price: ['ExactPrice', 'EstimatedPrice'],
    },
    typePolicies: {
        Quote: {
            fields: {
                quoteModels: {
                    merge: true,
                },
            },
        },
        QuoteModelRevision: {
            fields: {
                processesDetails: {
                    merge: true,
                },
            },
        },
        BusinessAccountDetails: {
            keyFields: ['businessAccountId'],
        },
        ActivateBusinessAccountMembers: {
            keyFields: ['membershipId'],
        },
        BusinessAccountQuote: {
            keyFields: ['quoteId'],
        },
        BusinessAccountInvite: {
            keyFields: ['email'],
        },
        SendBusinessAccountInviteError: {
            keyFields: ['email'],
        },
        BasicMoldTool: {
            keyFields: ['moldToolRevisionId'],
        },
        MfgPartnerLevelSnapshotDetails: {
            merge: true,
        },
        UserTeamMember: {
            keyFields: ['email', 'teamId'],
        },
        Part: {
            keyFields: ['id', 'name'],
        },
        Job: {
            keyFields: ['id', 'payout'],
        },
        OrderProcessDetails: {
            keyFields: [
                'id',
                'additionalSpecifications',
                'dfmNotes',
                'color',
                'texture',
                'thickness',
                'processNotes',
            ],
        },
        PartMaterialConfiguration: {
            keyFields: [
                'id',
                'additionalSpecifications',
                'dfmNotes',
                'color',
                'colorCode',
                'grade',
                'shoreValue',
            ],
        },
    },
}
